import { useRestPost, UseRestPostMutationOptions } from 'scbk-services';

import { APIS } from '../../constants/apiPaths';

export interface HolAstSetSetLogoutPopupResponse {
    id: string;
    type: string;
    fullImagePath: string;
    targetVersion: string;
    targetUrl: string;
    targetMenuId: string;
    targetParams: string;
    contents: string;
    contentsOne: string;
}

/**
 * [뱅킹업무] HOME 로그아웃 팝업
 */
export const useHolAstSetSetLogoutPopup = (
    mutationOptions?: UseRestPostMutationOptions<unknown, HolAstSetSetLogoutPopupResponse>,
) => {
    return useRestPost<unknown, HolAstSetSetLogoutPopupResponse>(
        {
            endpoint: APIS.holdings.assets.setting.setLogoutPopup,
        },
        mutationOptions,
    );
};
